import { useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';
import logWebPageDepthScrolled from '@alltrails/amplitude/events/logWebPageDepthScrolled';
import WebPageScrollDepth from '@alltrails/amplitude/enums/WebPageScrollDepth';

const SCROLL_DEPTH_INCREMENTS: { factor: number; depth: WebPageScrollDepth }[] = [
  { factor: 0.25, depth: 'twenty five percent' },
  { factor: 0.5, depth: 'fifty percent' },
  { factor: 0.75, depth: 'seventy five percent' },
  { factor: 1, depth: 'one hundred percent' }
];

export default function useLogDepthScrolled() {
  const maxScrollIndex = useRef(-1);

  useEffect(() => {
    const handleScroll = debounce(() => {
      if (maxScrollIndex.current === SCROLL_DEPTH_INCREMENTS.length - 1) return;

      const scrollableHeight = document.body.scrollHeight - window.innerHeight;
      const scrolled = window.scrollY;

      // only log the deepest scroll depth the user has reached, max once per depth increment
      let shouldLog = false;
      for (let i = maxScrollIndex.current + 1; i < SCROLL_DEPTH_INCREMENTS.length; i++) {
        if (scrolled / scrollableHeight >= SCROLL_DEPTH_INCREMENTS[i].factor) {
          maxScrollIndex.current = i;
          shouldLog = true;
        }
      }

      if (shouldLog) {
        logWebPageDepthScrolled({ scroll_depth: SCROLL_DEPTH_INCREMENTS[maxScrollIndex.current].depth, href: window.location.href });
      }
    }, 50);

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);
}
